import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { LibTableComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';
import { AppUploadActionComponent } from './upload-action/upload-action.component';
import { AppUploadCustomActionComponent } from './upload-custom-action/upload-custom-action.component';
import { UploadZoneComponent } from './upload-action/upload-zone';

@Component({
  standalone: true,
  selector: 'app-documents-upload-table',
  imports: [
    ...tuainFormsBaseModules,
    ...tuainBaseComponents,
    AppUploadActionComponent,
    AppUploadCustomActionComponent,
    UploadZoneComponent,
  ],
  templateUrl: './documents-upload-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./documents-upload-table.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsUploadTableComponent extends LibTableComponent {
  cardActions: any = {};
  /** Mensaje del documento abierto en el modal (`null` = cerrado). */
  comment = signal<{ title: string; text: string } | null>(null);

  override start() {
    super.start();
    this.inlineActions.forEach(act => {
      this.cardActions[act.actionCode] = act;
    });
  }

  openComment(recordData: any) {
    const text = recordData?.documentComments;
    if (!text) {
      return;
    }
    this.comment.set({ title: recordData?.documentName || 'Mensaje sobre el documento', text });
  }

  closeComment() {
    this.comment.set(null);
  }
}
